/** The CMS-side Vercel Blob store (insurer logos, report and about images). */
export const SITE_BLOB_ORIGIN =
  "https://rc1mdjsplvzsekgk.public.blob.vercel-storage.com"

/** The `marketing-site-blob` store behind `blobMediaUrl()`. */
export const MEDIA_BLOB_ORIGIN = (
  process.env.NEXT_PUBLIC_BLOB_BASE_URL ?? ""
).replace(/\/$/, "")

/**
 * Same-origin prefix per Blob store, each a rewrite in next.config. These are
 * the only stores proxied: a store parameter would serve anyone's blob files
 * from this origin.
 */
export const BLOB_REWRITES = [
  { prefix: "/blob-assets", origin: SITE_BLOB_ORIGIN },
  { prefix: "/blob-media", origin: MEDIA_BLOB_ORIGIN },
].filter((r) => r.origin)

/**
 * Blob URL → its same-origin path, for images the browser fetches itself (a
 * raw `<img>` or an `unoptimized` `Image`). Vercel's firewall sometimes
 * answers a visitor's direct request to the blob host with its HTML security
 * checkpoint (403, `x-vercel-mitigated: challenge`); an `<img>` cannot pass
 * that challenge and Chromium blocks the HTML as ERR_BLOCKED_BY_ORB. Through
 * the rewrite the blob host is fetched by Vercel, not by the visitor. Other
 * URLs pass through.
 */
export function sameOriginBlobUrl(url: string): string {
  const store = BLOB_REWRITES.find((r) => url.startsWith(`${r.origin}/`))
  return store ? `${store.prefix}/${url.slice(store.origin.length + 1)}` : url
}
